export default __webpack_public_path__ + "static/media/cliente09_color.51b58b35.png";